<template>
  <footer class="glass-footer" :class="themeClass">
    <div class="footer-content">
      <p class="footer-text">
        &copy; VITRAIL-A {{ currentYear }} | 
        <router-link to="/mentions-legales" class="footer-link">Mentions légales</router-link>
      </p>
    </div>
  </footer>
</template>

<script>
import { useThemeStore } from '@/stores/theme';

export default {
  name: "FooterComponent",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
    themeClass() {
      const themeStore = useThemeStore();
      return `theme-${themeStore.activeTheme}`;
    }
  }
}
</script>

<style scoped>
.glass-footer {
  background: rgba(30, 40, 55, 0.8);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 1.5rem 0;
  transition: all 0.3s ease;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  text-align: center;
}

.footer-text {
  margin: 0;
  font-size: 0.875rem;
  color: var(--color-text-secondary, #cccccc);
}

.footer-link {
  color: var(--theme-primary, #59a96a);
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-link:hover {
  color: var(--theme-primary-light, #7bc08a);
  text-decoration: underline;
}

/* Theme Default (Green) */
.theme-default.glass-footer {
  background: rgba(20, 45, 30, 0.85);
  border-top-color: rgba(89, 169, 106, 0.2);
}

.theme-default .footer-link {
  color: var(--theme-primary);
}

.theme-default .footer-link:hover {
  color: var(--theme-primary-light);
}

/* Theme Medical (Blue) */
.theme-medical.glass-footer {
  background: rgba(20, 35, 50, 0.85);
  border-top-color: rgba(59, 136, 165, 0.2);
}

.theme-medical .footer-link {
  color: var(--theme-primary);
}

.theme-medical .footer-link:hover {
  color: var(--theme-primary-light);
}

/* Theme Admin (Dark) */
.theme-admin.glass-footer {
  background: rgba(15, 18, 30, 0.95);
  border-top-color: rgba(59, 136, 165, 0.3);
}

.theme-admin .footer-text {
  color: rgba(255, 255, 255, 0.6);
}

.theme-admin .footer-link {
  color: var(--theme-primary);
}

.theme-admin .footer-link:hover {
  color: var(--theme-primary-light);
}
</style>